export default class scrollbutton extends PIXI.Sprite {
	constructor(texture, icon) {
		super(texture);

		this.signals = {
			click : new P3.utils.MiniSignal(),
			up    : new P3.utils.MiniSignal(),
			down  : new P3.utils.MiniSignal(),
			hover : new P3.utils.MiniSignal()
		};

		this._icon = null;

		this._isPressed = false;
		this._isOver = false;

		this.interactive = true;
		this.buttonMode = true;

		this.anchor.set(0.5);

		this.init(icon);
	}

	init(icon) {
		if (icon) {
			this._icon = new PIXI.Sprite(icon);
			this._icon.anchor.set(0.5);
			this.addChild(this._icon);
		}

		this.on('pointerdown', (e) => {
			this.onPointerDown(e);
		}, this);

		this.on('pointerup', (e) => {
			this.onPointerUp(e);
		}, this);

		this.on('pointerupoutside', (e) => {
			this.onPointerUp(e);
		}, this);

		this.on('pointerover', (e) => {
			this.onPointerOver(e);
		}, this);

		this.on('pointerout', (e) => {
			this.onPointerOut(e);
		}, this);

		this.on('pointertap', (e) => {
			P3.audio.playSound('sfx_btn_press_00');
			this.onPointerTap(e);
		}, this);
	}

	onPointerDown(e) {
		this._isPressed = true;
		this.signals.down.dispatch(e);
	}

	onPointerUp(e) {
		this._isPressed = false;
		this.signals.up.dispatch(e);
	}

	onPointerOver(e) {
		this._isOver = true;
		this.signals.hover.dispatch(e);
	}

	onPointerOut() {
		this._isOver = false;
	}

	onPointerTap(e) {
		this.signals.click.dispatch(e);
	}

	destroy() {
		super.destroy();
	}

	update() {
		super.update();
	}

	get isHeld() {
		return this._isPressed;
	}
}
